import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { config } from '../../../common/config'
import { getConfigBySite } from '../../../config/sites'
import EmptyResultsPlaceholder from '../../components/emptyResultsPlaceholder'
import HeroItemSection from '../../components/heroItemSection'
import ItemsGridWithSidebar from '../../components/itemsGridWithSidebar'
import LoadingCover from '../../components/loadingCover'
import PageContentSection from '../../components/pageContentSection'
import PageTextHeading from '../../components/pageTextHeading'
import SearchPageContentWrapper from '../../components/searchPageContentWrapper'
import ThumbnailsSidebar from '../../components/thumbnailsSidebar'
import UsDollarsNoticeContainer from '../../components/usDollarsNotice/usDollarsNoticeContainer'
import VideoControllsContainer from '../../components/video/videoControllsContainer'
import { Props } from '../../containers/featurePageContainer'

import * as styles from './featurePage.module.css'

const FeaturePage = (props: Props) => {
  const {
    featuredItems,
    featuredAuthors,
    location,
    experimentsReady,
    currentSite,
    isLoading,
    metadata
  } = props
  const hasItems = featuredItems && featuredItems.length > 0
  const firstItem = featuredItems[0]
  const restItems = featuredItems.slice(1)
  const firstItemViewType = getConfigBySite(
    currentSite,
    'ui.featured_hero_item_viewtype'
  )

  const shouldShowVideoControlls = currentSite === Site.videohive

  const defaultAvatarImgSrc = `${
    config.assets.PUBLIC_PATH
  }/images/default-user.jpg`

  const featuredAuthorsThumbnails = featuredAuthors.map(author => ({
    imgSrc: author.profile_image_url || defaultAvatarImgSrc,
    link: author.profile_path,
    title: author.username
  }))
  return (
    <article>
      <PageTextHeading
        title="Featured Files"
        subtitle={metadata && metadata.sub_heading}
      />
      <SearchPageContentWrapper experimentsReady={experimentsReady}>
        {isLoading && <LoadingCover />}
        {hasItems && (
          <div>
            <HeroItemSection
              item={firstItem}
              currentSite={currentSite}
              location={location}
              viewType={firstItemViewType}
            />
            <PageContentSection>
              <div className={styles.titleSection}>
                <h2 className={styles.subtitle}>
                  Items featured in the last 6 months
                </h2>
                <div className={styles.controls}>
                  <div className={styles.gstMsg}>
                    <UsDollarsNoticeContainer />
                  </div>
                  {shouldShowVideoControlls && (
                    <div className={styles.videoContrls}>
                      <VideoControllsContainer />
                    </div>
                  )}
                </div>
              </div>
              <ItemsGridWithSidebar
                items={restItems}
                location={location}
                sidebar={
                  <ThumbnailsSidebar
                    title="Featured Authors"
                    thumbnails={featuredAuthorsThumbnails}
                  />
                }
              />
            </PageContentSection>
          </div>
        )}
        {!hasItems && (
          <EmptyResultsPlaceholder
            heading="Nothing exists here"
            subHeading="We couldn't find any data for this page. Please try again later."
          />
        )}
      </SearchPageContentWrapper>
    </article>
  )
}

export default FeaturePage
